import React from 'react';
import { Card } from 'react-bootstrap-v5'

export default function EPaperCard({ name, image, link }) {
    return (
        <div className={'col-12 col-lg-4'}>
            <a href={link}>
                <Card>
                    <Card.Img variant="top" src={image} alt={name} />
                    <Card.Body>
                        <Card.Title className="text-center">{name}</Card.Title>
                    </Card.Body>
                </Card>
            </a>
        </div>
    )
}
